import { EmotionIconProps } from '@emotion-icons/emotion-icon'

export const LocationVisitsIcon = (props: EmotionIconProps) => {
  const { fill, color, size } = props
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.875 0H7.875C7.57663 0 7.29048 0.118526 7.0795 0.329505C6.86853 0.540483 6.75 0.826631 6.75 1.125V5.25064H7.875V1.125H11.8125V7.875H9.79875V9H16.875C17.1734 9 17.4595 8.88147 17.6705 8.67049C17.8815 8.45952 18 8.17337 18 7.875V1.125C18 0.826631 17.8815 0.540483 17.6705 0.329505C17.4595 0.118526 17.1734 0 16.875 0ZM16.875 1.125V7.875H15.9581L15.6656 7.66687C16.3125 7.4025 16.29 6.69937 16.29 6.69937C16.29 6.69937 16.3688 5.56313 14.9062 5.56313C13.4719 5.56313 13.4494 6.72187 13.4494 6.72187H14.3044C14.3044 6.26062 14.8331 6.2325 14.9062 6.2325C14.9906 6.2325 15.4688 6.2325 15.4463 6.795C15.4406 7.29562 14.9288 7.38562 14.9288 7.38562L14.3831 7.39125L14.3888 7.875H12.9375V1.125H13.6406C13.4325 1.49062 13.4269 1.86188 13.4269 1.86188L14.2931 1.85625C14.2931 1.85625 14.2144 1.15313 14.9062 1.125C15.6994 1.125 15.3788 2.06437 15.3 2.22187C15.2156 2.385 13.5 4.20187 13.5 4.20187L13.5225 4.76437L16.4475 4.78125L16.4419 4.095L14.5744 4.10625L15.885 2.67188C15.9806 2.53125 16.245 2.1375 16.2844 1.76063C16.2844 1.75755 16.2846 1.75227 16.2849 1.74498C16.2882 1.67243 16.3002 1.40104 16.1775 1.125H16.875Z"
        fill={fill || color || 'currentColor'}
      />
      <path
        d="M9.79875 6.75H10.6425V2.48062H10.5525L8.78625 3.11063V3.8025L9.79875 3.4875V6.75Z"
        fill={fill || color || 'currentColor'}
      />
      <path
        d="M6 12C7.6575 12 9 10.6575 9 9C9 7.3425 7.6575 6 6 6C4.3425 6 3 7.3425 3 9C3 10.6575 4.3425 12 6 12ZM6 13C3.9975 13 0 14.005 0 16V18H12V16C12 14.005 8.0025 13 6 13Z"
        fill={fill || color || 'currentColor'}
      />
    </svg>
  )
}
